import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import React from 'react'
import LayerGroups from './LayerGroups'
import LayerIcons from './LayerIcons'
import CommTaglibs from './Taglibs'
import CommTonings from './Tonings'
import MemeStickers from './MemeStickers'
import Notifications from './Notifications'
import FakeUsers from './FakeUsers'
import AvatarCardTemplates from './AvatarCardTemplates'
import { useTabQuery } from 'hooks/useQueryState'

const Index = () => {
  const [tab, setTab] = useTabQuery('commTab', 'tags')

  return (
    <div className="flex h-[calc(100vh-98px)] flex-col">
      <div className="mb-4 flex shrink-0 items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">Comm data</h2>
      </div>
      <Tabs
        value={tab}
        onValueChange={setTab}
        className="flex min-h-0 flex-1 flex-col"
      >
        <TabsList className="w-fit shrink-0">
          <TabsTrigger value="tags">Tags</TabsTrigger>
          <TabsTrigger value="layer-icons">Layer icons</TabsTrigger>
          <TabsTrigger value="tonings">Tonings</TabsTrigger>
          <TabsTrigger value="layer-groups">Layer groups</TabsTrigger>
          <TabsTrigger value="avatar-card-templates">
            Avatar Card Templates
          </TabsTrigger>
          <TabsTrigger value="meme-stickers">Meme stickers</TabsTrigger>
          <TabsTrigger value="notifications">Notifications</TabsTrigger>
          <TabsTrigger value="fake-users">Fake users</TabsTrigger>
        </TabsList>
        <TabsContent
          value="tags"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <CommTaglibs />
        </TabsContent>
        <TabsContent value="layer-icons" className="mt-4 space-y-4">
          <LayerIcons />
        </TabsContent>
        <TabsContent
          value="tonings"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <CommTonings />
        </TabsContent>
        <TabsContent
          value="layer-groups"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <LayerGroups />
        </TabsContent>
        <TabsContent
          value="avatar-card-templates"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <AvatarCardTemplates />
        </TabsContent>
        <TabsContent
          value="meme-stickers"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <MemeStickers />
        </TabsContent>
        <TabsContent
          value="notifications"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <Notifications />
        </TabsContent>
        <TabsContent
          value="fake-users"
          className="mt-4 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <FakeUsers />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default Index
